// ═══════════════════════════════════════════════════════════════
// HOOK: usePrestaciones - CORREGIDO COMPLETO
// Con conversión de fechas y extracción de montos
// ═══════════════════════════════════════════════════════════════

import { useState, useEffect } from 'react';
import api from '../api/config';
import { useCompany } from '../contexts/CompanyContext';

export function usePrestaciones() {
  const { currentCompany } = useCompany();
  const [prestaciones, setPrestaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (currentCompany) {
      loadPrestaciones();
    }
  }, [currentCompany]);

  /**
   * Cargar prestaciones desde la API
   */
  const loadPrestaciones = async () => {
    if (!currentCompany?.id) {
      setPrestaciones([]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await api.get(`/prestaciones/company/${currentCompany.id}`);
      
      console.log('✅ Prestaciones cargadas:', response.data);
      setPrestaciones(Array.isArray(response.data) ? response.data : []);
      setError(null);
    } catch (err) {
      console.error('❌ Error loading prestaciones:', err);
      setError(err.message);
      setPrestaciones([]);
    } finally {
      setLoading(false);
    }
  };

  /**
   * Agregar nueva prestación
   */
  const addPrestacion = async (params) => {
    if (!currentCompany?.id) throw new Error('No hay compañía seleccionada');
    try {
      // El backend recibe solo parámetros y recalcula internamente
      const response = await api.post('/prestaciones', {
        ...params,
        companyId: currentCompany.id,
      });
      await loadPrestaciones();
      return response.data;
    } catch (err) {
      console.error('❌ Error guardando prestación:', err);
      throw err;
    }
  };

  /**
   * Eliminar prestación
   */
  const deletePrestacion = async (id) => {
    try {
      await api.delete(`/prestaciones/${id}`);
      await loadPrestaciones();
    } catch (err) {
      console.error('❌ Error deleting prestacion:', err);
      throw err;
    }
  };

  /**
   * Marcar como pagada
   */
  const markAsPaid = async (id) => {
    try {
      await api.put(`/prestaciones/${id}/mark-paid`);
      await loadPrestaciones();
    } catch (err) {
      console.error('❌ Error marking as paid:', err);
      throw err;
    }
  };

  return {
    prestaciones,
    loading,
    error,
    addPrestacion,
    deletePrestacion,
    markAsPaid,
    reload: loadPrestaciones
  };
}

export default usePrestaciones;
